import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { register } from "@shopify/theme-sections";
import { ProductFormCharms } from "./react/ProductFormCharms";

register("product-form-charms", {
  onLoad() {
    const container = document.getElementById("ProductFormCharms");
    const root = createRoot(container);
    root.render(
      <StrictMode>
        <ProductFormCharms />
      </StrictMode>
    );
  },
});
